import React from 'react';
import './FeaturesBenefits2.css';
import { useNavigate } from 'react-router-dom';
import Carousal from '../components/Carousal';

const Footer = () => {
    const navigate= useNavigate();
    return (
        <div className='features-benefits'>
            {/* <div className='head'>
              <button className = 'back-button' onClick={() => navigate('/features')} >
                &#x227A;
              </button>
              <h5 style={{ color: '#fff' }} onClick={() => navigate('/features')} >Back</h5>
            </div> */}
            <div
              className="head"
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between', // Aligns Back and Get Started buttons to opposite sides
                padding: '10px 20px',
              }}
            >
              {/* Back Button */}
              <button
                className="back-button"
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                
                }}
                onClick={() => navigate('/features')}
              >
                &#x227A; Back
              </button>
              
              {/* Get Started Button */}
              <button
                className="get-started-button"
                style={{
                  backgroundColor: '#007bff', // Blue color for the button,
                  background: 'linear-gradient(45deg, #007bff, #024185)',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  // fontSize: '1rem',
                  padding: '8px 16px',
                  borderRadius: '25px',
                  textAlign: 'center',
                }}
                onClick={() => navigate('/')}
              >
                Get Started
              </button>
            </div>


           
            <div >
            <div className="poster-section-00">
                <div className="poster-content">
                <h1 className="poster-title-00">
                  <span className="highlight-big">Super Fast </span> 
                  <span ><i className=" highlight-blue poster-title">Super Powerful</i></span> 
                </h1>

                {/* <p style={{ backgroundColor: 'transparent' }}>CommentInsight for YouTube</p> */}
                
                </div>

             </div>

             <div className='carousal-center'>
              <Carousal />
             </div>
            <div className='column'>
            <div className="poster-section-11">
                <div className="poster-content">
                  <h1 className="poster-title">100+ Language</h1>
                  <p className="poster-subtitle">
                  Extract Valuable feedback from a wide range of languages commonly spoken on YouTube, including English, Hindi, Spanish, Arabic, Bengali, Portuguese, Russian, Japanese, and many more.
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>

             <div className="poster-section-22">
                <div className="poster-content">
                  <h1 className="poster-title">Community Post</h1>
                  <p className="poster-subtitle">
                  Analyze engagement and feedback from your YouTube community posts to connect better with your audience—coming soon!
                    
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>
            </div>
            <div className='column'>
            <div className="poster-section-11">
                <div className="poster-content">
                  <h1 className="poster-title">What Viewers Liked</h1>
                  <p className="poster-subtitle">
                  Discover the highlights of your content that resonated most with your audience.
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>

             <div className="poster-section-22">
                <div className="poster-content">
                  <h1 className="poster-title">What Viewers Disliked</h1>
                  <p className="poster-subtitle">
                  Identify aspects of your videos that didn’t meet viewer expectations for targeted improvements. 
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>
            </div>
            <div className='column'>
            <div className="poster-section-11">
                <div className="poster-content">
                  <h1 className="poster-title">Viewers' Requests <br></br>and Questions</h1>
                  <p className="poster-subtitle">
                  Uncover specific topics or ideas your audience wants to see more of or learn about.
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>

             <div className="poster-section-22">
                <div className="poster-content">
                  <h1 className="poster-title">Improvement Suggestions</h1>
                  <p className="poster-subtitle">
                  Gain actionable insights on how to elevate your content quality and engagement. 
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>
            </div>
             <div className="poster-section-3">
                <div className="poster-content">
                  <h1 className="poster-title"></h1>
                  <p className="poster-subtitle">
                    <span className='highlight-blue' >Stay ahead of the curve</span>
                     <br></br>by analyzing emerging video trends, audience preferences, and <br></br>content strategies <br></br>shaping the future of digital media.
                     </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

             <div className="poster-section-44">
                <div className="poster-content-44">
                  <h1 className="poster-title"></h1>
                  <p className="poster-subtitle-44">
                      Find gaps in coverage where your content can address audience interests.
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

             <div className="poster-section-55">
                <div className="poster-content">
                  <h1 className="poster-title">Content Strategy</h1>
                  <p className="poster-subtitle">
                   Plan, create, and optimize content that resonates with your audience to drive meaningful engagement and growth.
                  </p>
                  <button className="poster-button" onClick={()=>navigate("/")} >Get Started</button>
                </div>
                
             </div>

          

             
           
             </div>
             
             
            <div className="footer">
            <p>&copy; 2025 CommentInsight. All rights reserved.</p>
            </div>
        </div>
    );
    };

export default Footer;